import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, throwError, Observable, map, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TicketsService {
    id() {
        throw new Error('Method not implemented.');
    }
    httpOptions: HttpHeaders;

    selectedTaxonomy: any = '';
    private baseUrl = '/api/v1';

    selectedHierarchy: any = '';

    constructor(
        private http: HttpClient,
        private ngZone: NgZone
    ) {
        this.httpOptions = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        // Taxonomy
        this.selectedTaxonomy = localStorage.getItem('selectedTaxonomy');
        if (this.selectedTaxonomy) {
            this.selectedTaxonomy = JSON.parse(this.selectedTaxonomy);
        }
        // Version
        // Hierarchy
        this.selectedHierarchy = localStorage.getItem('selectedHierarchy');
        if (this.selectedHierarchy && this.selectedHierarchy != undefined) {
            // this.selectedHierarchy = JSON.parse(this.selectedHierarchy);
        } else {
            this.selectedHierarchy = null;
        }
    }

    getTicketsList(taxonomyId: string, params?: string) {
        let endPoint = '';

        endPoint = `${this.baseUrl}/taxonomies/${taxonomyId}/tickets`;
        if (params) {
            endPoint += `?${params}`;
        }

        return this.http.get<any>(endPoint).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => throwError(error))
        );
    }

    filtersApplied: any[] = [];

    getFilteredTicketList(selectedAuthor?: any) {
        const endPoint = `${this.baseUrl}/taxonomies/${this.selectedTaxonomy.id}/tickets?&author_id=${selectedAuthor}`;
        // &created_before?=''&created_after?=''&modified_before?=''&modified_after?=''&internal_ticket_id?=''&hierarchy_id?=''&category_name?=''&ticket_type?=''
        return this.http.get<any>(endPoint).pipe(
            map((response: any) => {
                this.setFilteredList(response, true);
                return response;
            }),
            catchError(error => throwError(error))
        );
    }
    // filteredList = new BehaviorSubject<any[]>([]);
    // filterAppliedSubject: BehaviorSubject<boolean> =
    //     new BehaviorSubject<boolean>(false);
    // filterApplied$: Observable<boolean> =
    //     this.filterAppliedSubject.asObservable();

    filtersAppliedset(value: boolean) {
        this.filterAppliedSubject.next(value);
    }

    filteredList = new BehaviorSubject<any[]>([]);
    filterAppliedSubject: BehaviorSubject<boolean> =
        new BehaviorSubject<boolean>(false);
    filterApplied$: Observable<boolean> =
        this.filterAppliedSubject.asObservable();

    setFilteredList(filteredList: any[], value: boolean): void {
        // Ensure the BehaviorSubject updates instantly by using a deep copy
        const newList = [...filteredList];
        this.filteredList.next(newList);
        this.filterAppliedSubject.next(value);
    }

    filtereAppliedFunction(): Observable<boolean> {
        return this.filterAppliedSubject.asObservable();
    }
    getFilteredList(): Observable<any[]> {
        return this.filteredList.asObservable();
    }

    getTicketDetail(ticketId: any) {
        // let endPoint = this.globals.urlJoin('tickets','ticketDetail')
        // endPoint.replace('api/v1/tickets/:ticket_id',`api/v1/tickets/${ticketId}`)
        const endPoint = `${this.baseUrl}/tickets/${ticketId}`;

        return this.http.get<any>(endPoint).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => throwError(error))
        );
    }
    createTicket(categoryDetailEdit: any): Observable<any> {
        // const csrftoken='tHZT1zGx2Rzu3b3e4HsvHhTz28HjAEwU';
        // const sessionid='fpagpvdra7sgog9ewc28z5zl421v7fx5'
        const csrftoken = '7dU7FxaH1lkNXCdZag8soYYrxkJENmMD';
        const sessionid = '8joj7isify8ofpzov5nu91vycduj4fyb';
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrftoken, // Include CSRF token in headers
            'Session-ID': sessionid,
        });
        // let endPoint = this.globals.urlJoin('tickets','ticketCreation')
        // endPoint.replace(`api/v1/taxonomies/:taxonomy_id/tickets`,`api/v1/taxonomies/${taxonomy_id}/tickets`)
        const endPoint = `${this.baseUrl}/tickets/batch`;
        return this.http.post<any>(endPoint, categoryDetailEdit, { headers });
    }
    submitTicket(ticket_id: any): Observable<any> {
        const csrftoken = 'tHZT1zGx2Rzu3b3e4HsvHhTz28HjAEwU';
        const sessionid = 'fpagpvdra7sgog9ewc28z5zl421v7fx5';
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrftoken, // Include CSRF token in headers
            'Session-ID': sessionid,
        });
        // let endPoint = this.globals.urlJoin('tickets','ticketCreation')
        // endPoint.replace(`api/v1/taxonomies/:taxonomy_id/tickets`,`api/v1/taxonomies/${taxonomy_id}/tickets`)
        const endPoint = `${this.baseUrl}/tickets/${ticket_id}/submit`;
        return this.http.post<any>(endPoint, { headers });
    }
    reviewTicket(ticket_id: any): Observable<any> {
        const csrftoken = 'tHZT1zGx2Rzu3b3e4HsvHhTz28HjAEwU';
        const sessionid = 'fpagpvdra7sgog9ewc28z5zl421v7fx5';
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrftoken, // Include CSRF token in headers
            'Session-ID': sessionid,
        });
        // let endPoint = this.globals.urlJoin('tickets','ticketCreation')
        // endPoint.replace(`api/v1/taxonomies/:taxonomy_id/tickets`,`api/v1/taxonomies/${taxonomy_id}/tickets`)
        const endPoint = `${this.baseUrl}/tickets/${ticket_id}/review`;
        return this.http.post<any>(endPoint, { headers });
    }
    approveTicket(ticket_id: any): Observable<any> {
        const csrftoken = 'tHZT1zGx2Rzu3b3e4HsvHhTz28HjAEwU';
        const sessionid = 'fpagpvdra7sgog9ewc28z5zl421v7fx5';
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrftoken, // Include CSRF token in headers
            'Session-ID': sessionid,
        });
        // let endPoint = this.globals.urlJoin('tickets','ticketCreation')
        // endPoint.replace(`api/v1/taxonomies/:taxonomy_id/tickets`,`api/v1/taxonomies/${taxonomy_id}/tickets`)
        const endPoint = `${this.baseUrl}/tickets/${ticket_id}/approve`;
        return this.http.post<any>(endPoint, { headers });
    }
    publishTicket(taxonomy_id: any): Observable<any> {
        const csrftoken = '7dU7FxaH1lkNXCdZag8soYYrxkJENmMD';
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrftoken,
        });
        const endPoint = `${this.baseUrl}/taxonomies/${taxonomy_id}/tickets/publish`;
        return this.http.post<any>(endPoint, headers);
    }
    ImpactedSkuList(ticket_id: any) {
        const endPoint = `${this.baseUrl}/tickets/${ticket_id}/impacted`;
        return this.http.get<any>(endPoint);
    }

    //userlist
    getUsers() {
        const endPoint = `${this.baseUrl}/users`;
        return this.http.get<any>(endPoint).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => throwError(error))
        );
    }
    private apiUrl = `${this.baseUrl}/tickets/copy/choices`;
    getCopyChoices(body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        // Use HttpClient's request method to specify a GET request with a body
        return this.http.request<any>('POST', this.apiUrl, { body, headers });
    }
    discardTicket(id: any): Observable<any> {
        const csrftoken = '7dU7FxaH1lkNXCdZag8soYYrxkJENmMD';
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrftoken,
        });
        const endPoint = `${this.baseUrl}/tickets/${id}/discard`;
        return this.http.post<any>(endPoint, headers);
    }
    rejectTicket(id: any): Observable<any> {
        const csrftoken = '7dU7FxaH1lkNXCdZag8soYYrxkJENmMD';
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrftoken,
        });
        const endPoint = `${this.baseUrl}/tickets/${id}/reject`;
        return this.http.post<any>(endPoint, headers);
    }
    changes: any = [];
    tickets: any = {};
    changesExist: boolean = true;
    clearData() {
        localStorage.setItem('ChangesProposed', JSON.stringify(this.changes));
        this.changesExist = false;
        localStorage.setItem('changesExist', JSON.stringify(this.changesExist));
        // localStorage.setItem('movedCategories',JSON.stringify(this.changes))
        localStorage.setItem('editPropeties', JSON.stringify(this.tickets));
        // // localStorage.setItem('changedAttributes',JSON.stringify(this.changes))
        localStorage.setItem('changedAttributes', JSON.stringify(this.tickets));
        localStorage.setItem('relationstickets', JSON.stringify(this.tickets));
        localStorage.setItem('changedAttributes', JSON.stringify(this.tickets));
    }

    getAttachments(ticket_id: number): Observable<any> {
        return this.http.get(`${this.baseUrl}/tickets/${ticket_id}/files`);
    }

    /** ✅ Upload attachment(s) for a ticket */
    uploadAttachment(ticket_id: number, files: File[]): Observable<any> {
        const formData = new FormData();
        files.forEach(file => {
            formData.append('attachments', file); // ✅ Ensure backend accepts multiple files
        });

        const headers = new HttpHeaders(); // Don't set `Content-Type`, Angular handles it

        return this.http.post(
            `${this.baseUrl}/tickets/${ticket_id}/files`,
            formData,
            { headers }
        );
    }
}
